'use client'

import { useEffect, useRef, useState } from 'react'
import { clientOnlyDynamic } from '@/lib/client-only-dynamic'
import type { NextNewsInfiniteScrollProps } from '@/components/NextNewsInfiniteScroll'

const NextNewsInfiniteScroll = clientOnlyDynamic(
  () => import('@/components/NextNewsInfiniteScroll'),
)

export default function LazyNextNewsInfiniteScroll(
  props: NextNewsInfiniteScrollProps,
) {
  const ref = useRef<HTMLDivElement>(null)
  const [show, setShow] = useState(false)

  useEffect(() => {
    const el = ref.current
    if (!el) return
    const io = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setShow(true)
          io.disconnect()
        }
      },
      { rootMargin: '600px 0px' },
    )
    io.observe(el)
    return () => io.disconnect()
  }, [])

  return <div ref={ref}>{show ? <NextNewsInfiniteScroll {...props} /> : null}</div>
}
